import React, { Component } from 'react'
import '../css/names.scss'
import Name from './Name';

export default class Names extends Component {
    render() {
        return (
            <div className="displayNames">
                {this.props.data.names.map(player =>  {
                    let back = ''
                    this.props.data.questions.forEach(element => {
                        if(element.player === player.id){ 
                            back = 'highlight'
                        }
                    });

                return <Name names={this.props.data} gameId={this.props.gameId} player={player} back={back} isadmin={this.props.isadmin} />})}
            </div>
        )
    }
}
